/**
 * Type-safe implementation of "key in object" Javascript idiom.
 */
export const has = <K extends string, T>(
    key: K,
    x: Record<string, T>,
): x is { [key in K]: T } => key in x;
